module.exports = __webpack_public_path__ + "static/media/logo.9ace7be0.png";